import { render, staticRenderFns } from "./page_header.vue?vue&type=template&id=2b012328&scoped=true&"
import script from "./page_header.vue?vue&type=script&lang=js&"
export * from "./page_header.vue?vue&type=script&lang=js&"
import style0 from "./page_header.vue?vue&type=style&index=0&id=2b012328&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"
import style2 from "./page_header.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b012328",
  null
  
)

export default component.exports